import React, { useState } from "react";
import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
import usePostHook from "../../customHooks/usePostHook";
import usePatchHook from "../../customHooks/usePatchHook";

const EditReturnBranchComponent = loadable(
  () => import("../../components/ReturnBranch/SwitchTab")
);
const EditReturnBranch = () => {
  const { id } = useParams();
  const [defaultValue, setDefaultValue] = useState(null);
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`return-branch-${id}`],
    url: `${APIS.RTV_BRANCH}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`return-branch-${id}`, "return-branch"],
    navigateURL: "",
  });
  const { data: gridData, isLoading: isStatusDataLoading } = useGetHook({
    queryKey: [`rtv-branch-status`],
    url: `${APIS.RTV_BRANCH_STATUS}`,
    params: {},
  });

  const { mutateAsync: toggleMarkAsDone, isLoading: isMarkAsDoneLoading } =
    usePatchHook({
      queryKey: [`return-branch-${id}`, "return-branch"],
      navigateURL: "",
    });
  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.RTV_BRANCH}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: attachConsignmentMutateAsync } = usePostHook({
    queryKey: ["rtv-branch-items"],
    navigateURL: "",
  });
  const { mutateAsync: checkConsignmentsMutateAsync } = usePostHook({
    queryKey: ["rtv-branch-items"],
  });

  const handleToggleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.RTV_BRANCH}${id}/`;
    let formData = {
      is_active: false,
    };
    try {
      await toggleMarkAsDone({ url, formData, setError });
      await refetch();
    } catch (err) {
      console.log(err);
    }
  };

  const handlecheckConsignments = async (consignmentId: string, setError) => {
    const url = `${APIS.RTV_BRANCH}receive-order/`;
    let formData = {
      tracking_number: consignmentId,
    };
    try {
      await checkConsignmentsMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const handleAttachConsignment = async (
    consignmentId: string,
    statusId: any,
    setError: any
  ) => {
    const url = `${APIS.RTV_BRANCH_ITEMS}`;
    let formData = {
      status_id: statusId,
      rtv_branch_order: id,
      tracking_number: consignmentId,
    };
    try {
      await attachConsignmentMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const handlePrint = async () => {
    const url = `${APIS.RTV_BRANCH}${id}/print-pdf-rtv/`;
    let formData = {};
    try {
      await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };
  const handleStatusChange = (data: any) => {
    setDefaultValue(data);
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit RTV Branch
        </span>
      </div>
      {isLoading || isStatusDataLoading ? (
        <Spinner />
      ) : (
        <EditReturnBranchComponent
          isLoading={isPatchLoading}
          data={data}
          handleEdit={handleEdit}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
          handlecheckConsignments={handlecheckConsignments}
          handleAttachConsignment={handleAttachConsignment}
          handleToggleMarkAsDone={handleToggleMarkAsDone}
          gridData={gridData}
          id={id}
          isPrintLoading={isPrintLoading}
          handleStatusChange={handleStatusChange}
          handlePrint={handlePrint}
        />
      )}
    </>
  );
};

export default EditReturnBranch;
